import { createContext, createElement, useContext } from "react";

const PhysicalExamTypeContext = createContext<string>("");

export function PhysicalExamTypeProvider({
  examType,
  children,
}: {
  examType: string;
  children: React.ReactNode;
}) {
  return createElement(PhysicalExamTypeContext.Provider, { value: examType }, children);
}

export function usePhysicalExamType() {
  return useContext(PhysicalExamTypeContext);
}
